// extracted by mini-css-extract-plugin
module.exports = {"base":"RegioHeader-module-base","hasMarginBottom":"RegioHeader-module-has-margin-bottom","logo":"RegioHeader-module-logo","link":"RegioHeader-module-link"};